import React from 'react';
import HomeItemsRenderer from 'UI/components/templates/HomeItemsCreation/HomeItemsRenderer';
import { FeatureFlags } from 'UI/constants/featureFlags';
import { hasFeatureFlag } from 'UI/utils';

/**
 * @param {Object} props
 * @param {boolean} props.canSelectCoach
 * @param {boolean} props.canSelectRegional
 * @param {*[]} props.columns
 * @param {undefined} props.EmptyPlaceholderRenderer
 * @param {(number|string)} [props.selectedCoachId]
 * @param {(number|string)} [props.selectedRegionalId]
 * @param {boolean} props.shouldShowHome
 */
const RendererChooser = ({
  canSelectCoach,
  canSelectRegional,
  columns,
  EmptyPlaceholderRenderer,
  selectedCoachId,
  selectedRegionalId,
  shouldShowHome
}) => {
  const areMultipleDivisionsEnable = hasFeatureFlag(FeatureFlags.HomeMultipleRegions);
  return shouldShowHome && columns ? (
    <HomeItemsRenderer
      columnsParam={columns}
      coachId={selectedCoachId}
      regionalId={areMultipleDivisionsEnable ? selectedRegionalId : null}
    />
  ) : (
    <EmptyPlaceholderRenderer
      shouldSelectTeam={
        areMultipleDivisionsEnable ? canSelectCoach || canSelectRegional : canSelectCoach
      }
    />
  );
};

export default RendererChooser;
